import { GraphQLObjectType, GraphQLString, GraphQLList, GraphQLBoolean } from 'graphql';

const curriculumSectionType = new GraphQLObjectType({
  name: 'CurriculumSectionType',
  fields: () => ({
    pid: {
      type: GraphQLString
    },
    name: {
      type: GraphQLString
    },
    description: {
      type: GraphQLString
    },
    image: {
      type: GraphQLString
    },
    hidden: {
      type: GraphQLBoolean
    },
    offerIds: {
      type: new GraphQLList(GraphQLString),
      resolve: (item) => {
        const rOfferIdsArray = [];
        item.offerIds.forEach((offerIdObject, index) => {
          rOfferIdsArray[index] = offerIdObject.value;
        });
        return rOfferIdsArray;
      }
    }
  })
});

window[curriculumSectionType.name + 'GQLType'] = curriculumSectionType;

export default curriculumSectionType;
